export default __webpack_public_path__ + "media/src/assets/images/upload_photo-4ac32f651f309ac2e924ef76688981e5.png";